import { Button } from "@material-ui/core"
import TextField from '@material-ui/core/TextField'
import React, { Component } from "react"
import { Link } from "react-router-dom"

import Wrapper from "../../../components/Common/Wrapper"
import SectionHeader from "../../../components/SectionHeader"
import ScheduleTable from "../../../components/Table/ScheduleTable"
import { knowledgeAreaArray } from "../../../Constants"
import { getPapersFromAccessCode, getReportsForPaper } from "../../../rebaseService"
import CustomAlert from "../../../components/CustomAlert"

class Reports extends Component {

    state = {
        learnMoredialog: false,
        getStartedDialog: false,
        papersToReview: [],
        papersAlreadyReviewed: [],
        accessCode: "",
        loaded: true
    }

    columnsWithBtn = [
        {
            name: "paperTitle",
            label: "Nome",
            options: {
                filter: false
            }
        },
        {
            name: "knowledgeArea",
            label: "Área de Conhecimento",
            options: {
                customBodyRender: (val) => {
                    const area = knowledgeAreaArray.find(k => val === k.value)
                    return <span>{area.title}</span>
                }
            }
        },
        {
            name: "Visualizar",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (index) => {
                    return (
                        <Button
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            component={Link}
                            to={"/avaliador/ver-paper/" + this.state.papersToReview[index].key}>
                            &#8594;
                        </Button>
                    )
                }
            }
        }
    ];


    columnsWithoutBtn = [
        {
            name: "paperTitle",
            label: "Nome",
            options: {
                filter: false
            }
        },
        {
            name: "knowledgeArea",
            label: "Área de Conhecimento",
            options: {
                customBodyRender: (val) => {
                    const area = knowledgeAreaArray.find(k => val === k.value)
                    return <span>{area.title}</span>
                }
            }
        },
    ];

    handleForm = async (e) => {
        try {
            e.preventDefault()
            this.setState({ loaded: false })
            let papersAlreadyReviewed = []
            let papersToReview = []
            let papersToReviewDB = await getPapersFromAccessCode(this.state.accessCode, this.props.user.knowledgeArea)
            for (let p of papersToReviewDB) {
                let reports = await getReportsForPaper(p.knowledgeArea, p.key)
                if (reports.length > 0) {
                    let reportsForTheReviewer = reports.filter(r => r.reviewer === this.state.accessCode)
                    for (let r of reportsForTheReviewer) {
                        if (r.status === 'open') {
                            papersToReview.push(p)
                        } else {
                            papersAlreadyReviewed.push(p)
                        }
                    }

                }
            }
            this.setState({ papersToReview, papersAlreadyReviewed })
        } catch (error) {
            console.log(error);
            this.setState({ fatalError: true })
        } finally {
            this.setState({ loaded: true })
        }
    }

    render() {

        return (
            <Wrapper loaded={this.state.loaded} fatalError={this.state.fatalError} currentPath={this.props.location.pathname} evaluatorTopbar>

                <SectionHeader
                    title="Trabalhos para revisar"
                    subtitle="A tabelas abaixo lista todos os trabalhos para revisar"
                />
                {
                    this.state.papersAlreadyReviewed.length > 0 ?
                        <ScheduleTable data={this.state.papersAlreadyReviewed} columns={this.columnsWithoutBtn} title={"Trabalhos já revisados"} />
                        :
                        <CustomAlert message="Nenhum trabalho revisado" />
                }
                {
                    this.state.papersToReview.length > 0 ?
                        <ScheduleTable data={this.state.papersToReview} columns={this.columnsWithBtn} title={"Trabalhos para revisão"} />
                        :
                        <>
                            <CustomAlert message="Nenhum trabalho para revisar" />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                onChange={e => this.setState({ accessCode: e.target.value })}
                                value={this.state.accessCode}
                                fullWidth
                                name="accesscode"
                                label="Senha"
                                type="password"
                                id="accesscode"
                                autoComplete="current-accesscode"
                            />
                            <Button
                                fullWidth
                                onClick={this.handleForm}
                                variant="contained"
                                color="primary"
                            >Acessar com código de acesso
                            </Button>
                        </>
                }


            </Wrapper>
        )
    }
}

export default Reports
